import _ from 'lodash';

import { getIsCellSelected, getLoanOptionPendingData } from '../RateTableCell/RateTableCell.utils';

export const getExtraTableRowOptions = ({
  rowData,
  selectedLoanProgramOption,
  pendingChanges,
  application,
  programId,
  noteRate,
}) => {
  const hasOptionsForSelection = _.some(rowData, i => !_.isNil(i?.finalBuyPrice));
  const hasTempSelectedOption = _.some(rowData, i =>
    getIsCellSelected({ ...i, selectedLoanProgramOption }),
  );

  const hasNewLoanOptionId = _.some(
    rowData,
    (o, key) =>
      getLoanOptionPendingData({
        pendingChanges,
        application,
        lockTerm: Number(key.replace(/[a-z]/gim, '')),
        finalBuyPrice: o?.finalBuyPrice,
        programId,
        noteRate,
      }).isNewLoanOptionId,
  );

  return { hasOptionsForSelection, hasTempSelectedOption, hasNewLoanOptionId };
};
